// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-09T19:45:00.211Z
// Property: Stadium House (ID: 6767906449167722)
// Collections: 16 amenities, 5 photos, 76 POIs, 4 reviews, 5 office hours, 6 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5760613594693632",
  "multihub_property_id": "6767906449167722",
  "property_external_id": null,
  "property_zillow_url": null,
  "property_apartments_url": null,
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "stadium-house",
  "property_name": "Stadium House",
  "property_website_url": "https://site-stadium-house-demo.pages.dev/",
  "property_domain": null,
  "property_address": "845 Spring St NW",
  "property_full_address": "845 Spring St NW, Atlanta, GA 30308",
  "property_address_1": "845 Spring St NW",
  "property_address_2": null,
  "property_address_city": "Atlanta",
  "property_address_state": "GA",
  "property_address_zip_full": null,
  "property_address_zip": "30308",
  "property_address_country": "US",
  "property_address_county": "Fulton County",
  "property_neighborhood_address": "Midtown Atlanta",
  "property_address_latitude": "33.7778877",
  "property_address_longitude": "-84.38812539999999",
  "property_email": "support@repli360.com",
  "property_phone": "5555555555",
  "property_call_tracking_phone": null,
  "property_company_name": "Rebel Residential",
  "property_company_url": null,
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": null,
  "property_long_description": null,
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020ae-130a-725f-9400-03984084df1b.webp",
  "property_featured_image_media": {
    "alt_text": "Cozy lounge area with pool table and ample seating.",
    "public_id": "01a020ae-130a-725f-9400-03984084df1b",
    "storage_key": "property/6767906449167722/01a020ae-130a-725f-9400-03984084df1b.webp",
    "width": 1728,
    "height": 1152
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": "150",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "70",
  "property_pet_restrictions": null,
  "property_pet_policy_description": "At Stadium House we understand that pets are part of your lifestyle. That’s why our community welcomes pets in our apartment homes with a pet policy designed to support both residents and their companions.",
  "property_petpolicy_info": "Your student apartment wouldn’t be complete without your pets - bring them along to pet-friendly Stadium House!",
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020af-6b67-7358-bfda-4e2783c274be.webp",
  "property_primary_logo_media": {
    "alt_text": "The SH logo in white on a black background",
    "public_id": "01a020af-6b67-7358-bfda-4e2783c274be",
    "storage_key": "property/6767906449167722/01a020af-6b67-7358-bfda-4e2783c274be.webp",
    "width": 237,
    "height": 317
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020e1-0058-733c-9021-7f89bc27feaf.webp",
  "property_secondary_logo_media": {
    "alt_text": "Stadium House logo",
    "public_id": "01a020e1-0058-733c-9021-7f89bc27feaf",
    "storage_key": "property/6767906449167722/01a020e1-0058-733c-9021-7f89bc27feaf.webp",
    "width": 368,
    "height": 310
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": null,
  "property_mono_black_logo_media": null,
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5760613594693632/01a03915-19b6-71d4-aeb8-805d7480607e.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#283990",
  "property_secondary_color": "#e8e8d9",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": null,
  "property_bedrooms_min": null,
  "property_bedrooms_max": null,
  "property_bathrooms_range": null,
  "property_bathrooms_min": null,
  "property_bathrooms_max": null,
  "property_sqft_range": null,
  "property_sqft_min": null,
  "property_sqft_max": null,
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": null,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ_zGq_2YE9YgRMZVMc3bwvmM",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Stadium House",
  "property_home_romance_title": "Embrace the Joy of Living in Your New Home",
  "property_home_amenities_blurb": null,
  "property_home_floorplans_blurb": null,
  "property_home_gallery_blurb": null,
  "property_home_neighborhood_blurb": null,
  "property_home_reviews_blurb": null,
  "property_neighborhood_blurb": "<p>Experience the best of student living just steps from Stadium House. Our community offers convenient access to popular dining spots, beautiful parks, shopping centers, and public transportation, making student life both exciting and easy.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At Stadium House, we’ve designed every space with student life in mind. Whether you’re focused on exams or just need to unwind, our community has it all - private study areas, a 24-hour fitness center, and a resort-style pool. From collaborative lounges to relaxing green spaces, our amenities are here to help you stay productive, connected, and refreshed.</p>",
  "property_applynow_blurb": null,
  "property_contactus_blurb": "<p>Ready to find your new student apartment near Georgia Institute of Technology? Contact Stadium House today to schedule a tour, ask about availability, or get leasing information. Our friendly leasing team is here to help you every step of the way.</p>",
  "property_faqs_blurb": "<p>Have questions about the community, apartments, amenities, or leasing process? We’ve got answers</p>",
  "property_floorplans_blurb": "<p>Find your perfect fit at Stadium House, where we offer fully furnished student apartments designed for your lifestyle. Choose from a variety of floor plans—whether you prefer the privacy of a one-bedroom or the social vibe of shared spaces with roommates. Each apartment features modern finishes, high-speed internet, and in-unit laundry for ultimate convenience. With layouts built around student needs, it's easy to stay focused, connected, and comfortable.</p>",
  "property_gallery_blurb": "<p>Get a closer look at life in our student community in Atlanta, GA through our gallery. From fully furnished apartments to fitness areas, and community hangout spots, our photo collection showcases the comfort, style, and convenience you can expect. Picture yourself here - close to nearby college campuses, surrounded by everything you need.</p>",
  "property_interactivemap_blurb": null,
  "property_pets_blurb": "<p>Your student apartment wouldn’t be complete without your pets - bring them along to pet-friendly Stadium House!</p>",
  "property_referafriend_blurb": null,
  "property_residentaccess_blurb": null,
  "property_reviews_blurb": null,
  "property_created_at": "1787254005729",
  "property_scheduletour_blurb": null,
  "property_thankyou_blurb": null,
  "property_virtualtours_blurb": "<p>eyJpdiI6IlVPQXRUYTRZV1dFcG13dkI2RUZhY1E9PSIsInZhbHVlIjoiZ242dHhBa2lwVlRjeldCTVZScmpyQT09IiwibWFjIjoiNjNjNTQ5MzIwMWJlMWU3NjBhZTEwYTQ3ZjZkZTg5NTEyYjA3ODJlYmQyOTFiOTc4YmQ3ZjIyZjZiYTBhMGNlYyJ9</p>",
  "property_copyright": null,
  "property_seo_title_home": null,
  "property_seo_description_home": null,
  "property_seo_title_floorplans": null,
  "property_seo_description_floorplans": null,
  "property_seo_title_amenities": null,
  "property_seo_description_amenities": null,
  "property_seo_title_gallery": null,
  "property_seo_description_gallery": null,
  "property_seo_title_virtualtours": null,
  "property_seo_description_virtualtours": null,
  "property_seo_title_interactivemap": null,
  "property_seo_description_interactivemap": null,
  "property_seo_title_neighborhood": null,
  "property_seo_description_neighborhood": null,
  "property_seo_title_contact": null,
  "property_seo_description_contact": null,
  "property_seo_title_faqs": null,
  "property_seo_description_faqs": null,
  "property_seo_title_reviews": null,
  "property_seo_description_reviews": null,
  "property_seo_title_applynow": null,
  "property_seo_description_applynow": null,
  "property_seo_title_residentaccess": null,
  "property_seo_description_residentaccess": null,
  "property_seo_title_referafriend": null,
  "property_seo_description_referafriend": null,
  "property_seo_title_scheduletour": null,
  "property_seo_description_scheduletour": null,
  "property_seo_title_privacy": null,
  "property_seo_description_privacy": null,
  "property_seo_title_accessibility": null,
  "property_seo_description_accessibility": null,
  "property_seo_title_sitemap": null,
  "property_seo_description_sitemap": null,
  "property_seo_title_thankyou": null,
  "property_seo_description_thankyou": null,
  "property_seo_title_pets": "Pet Policy | Apartments in Atlanta, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787598681818",
  "amenities": [
    {
      "id": "custom_2f314fcd-41f7-4e6c-99f8-a00a451292cc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "custom",
      "external_id": "false",
      "title": "24/7 Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_99f8fbf0-3e4e-42b1-aa84-4f28a2e153b5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "custom",
      "external_id": "false",
      "title": "Study Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0670718f-5074-4abd-bcab-a4b79ec48d59",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "custom",
      "external_id": "false",
      "title": "Resort-Style Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ea14d594-0b70-4576-8dae-dbd23012d2b7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "custom",
      "external_id": "false",
      "title": "Yoga Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e1a98674-4933-4bd8-9f99-add946d954d0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_86d606d9-c4ef-4fd4-acd7-2003c13ce2b9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "custom",
      "external_id": "false",
      "title": "Furnished Rooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_50d4d30e-d487-41c8-92e9-7cf402a8f273",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "custom",
      "external_id": "false",
      "title": "Bike Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0fefb71f-2c08-4d4c-9ca2-835200035112",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Wash Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_26e1b8c9-7696-4baa-82a0-06e763d03341",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "custom",
      "external_id": "false",
      "title": "EV Car Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_419fd657-fc1f-4ad8-a5f0-7d296d40f5cb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "custom",
      "external_id": "false",
      "title": "Cable And High Speed WiFi",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9896bbd7-fee5-4756-8db8-80547015a1c6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Kitchen Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0a418a1b-cf16-40b5-abf5-d53124fa8226",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "custom",
      "external_id": "false",
      "title": "In Unit Washer and Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_206bce65-942e-456a-bcb7-999d0b086e10",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "custom",
      "external_id": "false",
      "title": "Wall-Mounted Smart TV",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7c8cecb1-5c2e-4e58-8f2e-72b911d31c09",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "custom",
      "external_id": "false",
      "title": "Latch Keyless Entry System",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c63f0ae0-a6c1-4ac6-90dc-b4f4a4371a2c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "custom",
      "external_id": "false",
      "title": "Simulated Hardwood Flooring In All Main Areas",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_177db5dd-c01f-4f84-9107-4a5b14060148",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "custom",
      "external_id": "false",
      "title": "High Ceilings, Oversized Windows, And Open Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_62da007d-c7fe-4f4d-8fe0-386c945a59be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020ae-1312-74d4-bca8-f82029d2cc3c.webp",
      "image_media": {
        "alt_text": "Gym with weight machines, cardio equipment, and exposed brick walls.",
        "public_id": "01a020ae-1312-74d4-bca8-f82029d2cc3c",
        "storage_key": "property/6767906449167722/01a020ae-1312-74d4-bca8-f82029d2cc3c.webp",
        "width": 1728,
        "height": 1152
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a variety of weight machines, cardio equipment, and ample space for training. \"TRAINING YARD\" painted on brick wall.",
      "link": "",
      "alt_text": "Gym with weight machines, cardio equipment, and exposed brick walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5a14840a-4767-4428-8002-0767a6e37d45",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020ae-130a-725f-9400-03984084df1b.webp",
      "image_media": {
        "alt_text": "Cozy lounge area with pool table and ample seating.",
        "public_id": "01a020ae-130a-725f-9400-03984084df1b",
        "storage_key": "property/6767906449167722/01a020ae-130a-725f-9400-03984084df1b.webp",
        "width": 1728,
        "height": 1152
      },
      "title": "Community",
      "description": "Relax and unwind in our spacious lounge, featuring a pool table and comfortable seating areas perfect for socializing or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Cozy lounge area with pool table and ample seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0e41f39b-87cb-4ccc-b8dd-852a22385ed3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020ae-1307-724b-a8d9-f198609cfc3a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, light wood cabinets, and gray countertops.",
        "public_id": "01a020ae-1307-724b-a8d9-f198609cfc3a",
        "storage_key": "property/6767906449167722/01a020ae-1307-724b-a8d9-f198609cfc3a.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "A sleek and functional kitchen featuring stainless steel appliances, ample cabinet space, and elegant countertops, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, light wood cabinets, and gray countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9252495e-a9d1-4d3d-bb99-df1f1f1c56e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020ae-1302-7148-919b-65265d7936ea.webp",
      "image_media": {
        "alt_text": "Living room with a blue sectional sofa, coffee table with decor, and framed art on a brick wall.",
        "public_id": "01a020ae-1302-7148-919b-65265d7936ea",
        "storage_key": "property/6767906449167722/01a020ae-1302-7148-919b-65265d7936ea.webp",
        "width": 1728,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Relax in comfort in this stylish living room, featuring a spacious blue sectional sofa, a unique coffee table, and decorative wall art that adds a touch of personality.",
      "link": "",
      "alt_text": "Living room with a blue sectional sofa, coffee table with decor, and framed art on a brick wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c26589de-f6c3-4e02-9b2c-ffef23030bf7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020ae-1300-76ab-925e-ffe77e7cb47e.webp",
      "image_media": {
        "alt_text": "Group of people practicing yoga in a bright studio.",
        "public_id": "01a020ae-1300-76ab-925e-ffe77e7cb47e",
        "storage_key": "property/6767906449167722/01a020ae-1300-76ab-925e-ffe77e7cb47e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Lifestyle",
      "description": "Experience wellness and tranquility in our on-site yoga studio. Perfect for unwinding and staying active.",
      "link": "",
      "alt_text": "Group of people practicing yoga in a bright studio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_363e8670012dd3d1fb909d0d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "MidCity",
      "poi_type": "Restaurants",
      "poi_address": "850 W Peachtree St NW, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-75cd-714f-9b16-f619dec54a44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-75cd-714f-9b16-f619dec54a44",
        "storage_key": "property/6767906449167722/01a020a6-75cd-714f-9b16-f619dec54a44.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5082154270299397241&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midcity",
      "poi_latitude": "33.777774",
      "poi_longitude": "-84.3874814",
      "poi_miles_from_property": "341 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-c7fb-7548-b464-3eff8f2f4dca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a6-c7fb-7548-b464-3eff8f2f4dca",
        "storage_key": "property/6767906449167722/01a020a6-c7fb-7548-b464-3eff8f2f4dca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZeNtVGYE9YgReRzu5mFwh0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cocktail_bar"
    },
    {
      "id": "ec_a147405529d77951047a0025",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Bytes",
      "poi_type": "Restaurants",
      "poi_address": "848 Spring St NW Ste A, Atlanta, GA 30308, USA",
      "poi_short_description": "Easygoing, white-hued gastropub offering pub grub staples such as burgers plus cocktails & beers.",
      "poi_long_description": "Easygoing, white-hued gastropub offering pub grub staples such as burgers plus cocktails & beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-6b6b-701c-82d4-b87bf6d382f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-6b6b-701c-82d4-b87bf6d382f6",
        "storage_key": "property/6767906449167722/01a020a6-6b6b-701c-82d4-b87bf6d382f6.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1955305121556020321&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bytes",
      "poi_latitude": "33.7779832",
      "poi_longitude": "-84.38900459999999",
      "poi_miles_from_property": "223 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 470-447-2601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a0e-7709-b61e-5592a8a9e001",
        "storage_key": "property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPR4S4mYE9YgRYTzZ_aWjIhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gastropub"
    },
    {
      "id": "ec_df9be98cc2efa6f8b0f53443",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Tech Square Tavern",
      "poi_type": "Restaurants",
      "poi_address": "800 Spring St NW, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-6945-76ac-967f-91ea67719195.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-6945-76ac-967f-91ea67719195",
        "storage_key": "property/6767906449167722/01a020a6-6945-76ac-967f-91ea67719195.webp",
        "width": 1280,
        "height": 879
      },
      "poi_business_url": "https://www.gatechhotel.com/dining/tech-square-tavern",
      "poi_directions_map_url": "https://maps.google.com/?cid=6580794094159201178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tech-square-tavern",
      "poi_latitude": "33.77640239999999",
      "poi_longitude": "-84.38926",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-347-9440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a0e-7709-b61e-5592a8a9e001",
        "storage_key": "property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHV5iwxUF9YgRmgNZslytU1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_c40334c7f45940f4740914aa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Sankranti Indian Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "85 5th St NW Ste A, Atlanta, GA 30308, USA",
      "poi_short_description": "Modern Indian spot serving bowls, salads, and samosas in a casual setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-6f3c-71db-9c01-dc1087e1e35e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-6f3c-71db-9c01-dc1087e1e35e",
        "storage_key": "property/6767906449167722/01a020a6-6f3c-71db-9c01-dc1087e1e35e.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.sankranti.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10776592348170998256&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sankranti-indian-kitchen",
      "poi_latitude": "33.7770706",
      "poi_longitude": "-84.39026679999999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 470-240-8622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a0e-7709-b61e-5592a8a9e001",
        "storage_key": "property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIWyGAsEF9YgR8NHs0aQljpU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "ec_b3484b23001a44cf913a97c1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Tin Drum Asian Kitchen & Boba Tea Bar - Georgia Tech",
      "poi_type": "Restaurants",
      "poi_address": "88 5th St NW, Atlanta, GA 30308, USA",
      "poi_short_description": "Hip cafe chain serving Pan-Asian fare, such as Indian curries & Chinese noodles.",
      "poi_long_description": "Hip cafe chain serving Pan-Asian fare, such as Indian curries & Chinese noodles.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-6ba2-7018-93b6-761ebbb0a17e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-6ba2-7018-93b6-761ebbb0a17e",
        "storage_key": "property/6767906449167722/01a020a6-6ba2-7018-93b6-761ebbb0a17e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tindrumasiankitchen.com/georgia-tech-atlanta-ga",
      "poi_directions_map_url": "https://maps.google.com/?cid=12273254479326605378&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tin-drum-asian-kitchen--boba-tea-bar---georgia-tech",
      "poi_latitude": "33.7766331",
      "poi_longitude": "-84.39004670000001",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-881-1368",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a0e-7709-b61e-5592a8a9e001",
        "storage_key": "property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpVnUxmYE9YgRQvA7JuxbU6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_c73db9d27dc7f5f1a37c6b88",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Gyro Bros.",
      "poi_type": "Restaurants",
      "poi_address": "85 5th St NW B, Atlanta, GA 30332, USA",
      "poi_short_description": "Casual, veteran-owned eatery serving tasty gyros and other Mediterranean items, plus fries and salads.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-6e11-7798-8153-019b5b8a10a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-6e11-7798-8153-019b5b8a10a6",
        "storage_key": "property/6767906449167722/01a020a6-6e11-7798-8153-019b5b8a10a6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gyrobrosatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11580291870457630704&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gyro-bros",
      "poi_latitude": "33.7770528",
      "poi_longitude": "-84.3900992",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-892-5707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a0e-7709-b61e-5592a8a9e001",
        "storage_key": "property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfVDbwmYE9YgR8I_45Rl2taA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "greek_restaurant"
    },
    {
      "id": "ec_c4f89c7a3906a3b5f10db5ac",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Ray's New York Pizza",
      "poi_type": "Restaurants",
      "poi_address": "26 5th St NW, Atlanta, GA 30332, USA",
      "poi_short_description": "Branch of chain pizzeria also offers sandwiches & pastas plus Mediterranean fare & upstairs seating.",
      "poi_long_description": "Branch of chain pizzeria also offers sandwiches & pastas plus Mediterranean fare & upstairs seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-713a-76c1-8c97-ab5fd14903d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-713a-76c1-8c97-ab5fd14903d1",
        "storage_key": "property/6767906449167722/01a020a6-713a-76c1-8c97-ab5fd14903d1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.raysnewyorkpizza.com/?utm_source=google&utm_medium=wix_google_business_profile&utm_campaign=15318366614929564075",
      "poi_directions_map_url": "https://maps.google.com/?cid=9135719434802151797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rays-new-york-pizza",
      "poi_latitude": "33.7766683",
      "poi_longitude": "-84.3882138",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-888-9911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a0e-7709-b61e-5592a8a9e001",
        "storage_key": "property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz0OaXmYE9YgRdcEDP2yYyH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_2c05e76643f1a91d05a0369d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Momonoki",
      "poi_type": "Restaurants",
      "poi_address": "95 8th St NW #100, Atlanta, GA 30309, USA",
      "poi_short_description": "Ramen, poke bowls & other Japanese eats offered in an airy, contemporary space with counter seating.",
      "poi_long_description": "Ramen, poke bowls & other Japanese eats offered in an airy, contemporary space with counter seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-693f-76bd-9fb9-e83f2ba525ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-693f-76bd-9fb9-e83f2ba525ba",
        "storage_key": "property/6767906449167722/01a020a6-693f-76bd-9fb9-e83f2ba525ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://momonokiatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15049215442563056401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "momonoki",
      "poi_latitude": "33.7797614",
      "poi_longitude": "-84.3902573",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-390-3025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a0e-7709-b61e-5592a8a9e001",
        "storage_key": "property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvX5_WjoF9YgREUNL-rWN2dA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ramen_restaurant"
    },
    {
      "id": "ec_7cd85625bd5c3543ae1e28fe",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Umma's House Korean Japanese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "75 5th St NW, Atlanta, GA 30332, USA",
      "poi_short_description": "Basic, low-key counter-serve spot selling homey Japanese & Korean dishes, bubble tea & smoothies.",
      "poi_long_description": "Basic, low-key counter-serve spot selling homey Japanese & Korean dishes, bubble tea & smoothies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-6e6e-702d-9de7-1a4dd3468001.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-6e6e-702d-9de7-1a4dd3468001",
        "storage_key": "property/6767906449167722/01a020a6-6e6e-702d-9de7-1a4dd3468001.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://umma-restaurant.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1142214935815974490&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ummas-house-korean-japanese-restaurant",
      "poi_latitude": "33.7772587",
      "poi_longitude": "-84.3892249",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 404-477-3255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a0e-7709-b61e-5592a8a9e001",
        "storage_key": "property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNeFB72YE9YgRWu50sm722Q8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_f14a7d72237e332046ae7779",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Hikaru Ramen & Buffalo Wings",
      "poi_type": "Restaurants",
      "poi_address": "756 W Peachtree St NW, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-732b-7498-a0fd-264668f36737.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-732b-7498-a0fd-264668f36737",
        "storage_key": "property/6767906449167722/01a020a6-732b-7498-a0fd-264668f36737.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://hikaruramen-codafoodhall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5451138296782295325&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hikaru-ramen--buffalo-wings",
      "poi_latitude": "33.7752992",
      "poi_longitude": "-84.38850800000002",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 678-800-8004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a0e-7709-b61e-5592a8a9e001",
        "storage_key": "property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkSseJV0F9YgRHZE8SWZVpks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_bb895319795ccbcfaf90c000",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "The Varsity",
      "poi_type": "Restaurants",
      "poi_address": "61 North Ave NW, Atlanta, GA 30308, USA",
      "poi_short_description": "Long-running drive-in chain serving up burgers, hot dogs, fries, shakes & other American classics.",
      "poi_long_description": "Long-running drive-in chain serving up burgers, hot dogs, fries, shakes & other American classics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a3-f42b-70ac-a9e3-9a713fdc0939.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a3-f42b-70ac-a9e3-9a713fdc0939",
        "storage_key": "property/6767906449167722/01a020a3-f42b-70ac-a9e3-9a713fdc0939.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://thevarsity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16355400820245921208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-varsity",
      "poi_latitude": "33.7715946",
      "poi_longitude": "-84.3893032",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-881-1706",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a0e-7709-b61e-5592a8a9e001",
        "storage_key": "property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWWUM7mQE9YgRuP3jMWQO-uI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_564e459c6e7d36c13ab7a997",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "The Vortex Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "878 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Local fixture known for its burgers, beer & whiskey selection & offbeat, rock 'n' roll vibe.",
      "poi_long_description": "Local fixture known for its burgers, beer & whiskey selection & offbeat, rock 'n' roll vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-7768-74b8-b320-4b49ddb28c64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-7768-74b8-b320-4b49ddb28c64",
        "storage_key": "property/6767906449167722/01a020a6-7768-74b8-b320-4b49ddb28c64.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.thevortexbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2105728285314260711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-vortex-bar--grill",
      "poi_latitude": "33.7790602",
      "poi_longitude": "-84.3844407",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-875-1667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a0e-7709-b61e-5592a8a9e001",
        "storage_key": "property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-icamgE9YgR5x6mB7gMOR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_0d619b6d18a2cbe923d4a894",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "South City Kitchen Midtown",
      "poi_type": "Restaurants",
      "poi_address": "1144 Crescent Ave NE, Atlanta, GA 30309, USA",
      "poi_short_description": "Inventive takes on Southern classics, including a popular brunch, served in upscale surroundings.",
      "poi_long_description": "Inventive takes on Southern classics, including a popular brunch, served in upscale surroundings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-7d3f-747b-9ebb-25abe04c5f87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-7d3f-747b-9ebb-25abe04c5f87",
        "storage_key": "property/6767906449167722/01a020a6-7d3f-747b-9ebb-25abe04c5f87.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.southcitykitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11724931360973815545&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-city-kitchen-midtown",
      "poi_latitude": "33.7859545",
      "poi_longitude": "-84.3844341",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-873-7358",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a0e-7709-b61e-5592a8a9e001",
        "storage_key": "property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvQqtX0ME9YgR-X6ukvNSt6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_763ca1040c1dc63c0dcbc71e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Mary Mac's Tea Room",
      "poi_type": "Restaurants",
      "poi_address": "224 Ponce De Leon Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "This 1945-era institution draws locals & tourists for Southern comfort food in a homey space.",
      "poi_long_description": "This 1945-era institution draws locals & tourists for Southern comfort food in a homey space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-7701-75b9-a4a7-8e44f0376fc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-7701-75b9-a4a7-8e44f0376fc4",
        "storage_key": "property/6767906449167722/01a020a6-7701-75b9-a4a7-8e44f0376fc4.webp",
        "width": 1080,
        "height": 1280
      },
      "poi_business_url": "http://www.marymacs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14428011323645827231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mary-macs-tea-room",
      "poi_latitude": "33.7728043",
      "poi_longitude": "-84.3798348",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-876-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a0e-7709-b61e-5592a8a9e001",
        "storage_key": "property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgUolJWwE9YgRnxg5IduXOsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_1fe63433745d582c9cc6f39b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Midtown - White Windmill Bakery & Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1331 Spring St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-79cb-768c-acb2-f9dd9b58e70e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-79cb-768c-acb2-f9dd9b58e70e",
        "storage_key": "property/6767906449167722/01a020a6-79cb-768c-acb2-f9dd9b58e70e.webp",
        "width": 854,
        "height": 1280
      },
      "poi_business_url": "https://www.whitewbakerycafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11288773099995012024&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midtown---white-windmill-bakery--cafe",
      "poi_latitude": "33.7911962",
      "poi_longitude": "-84.3885291",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-209-2557",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a0e-7709-b61e-5592a8a9e001",
        "storage_key": "property/6767906449167722/01a020a4-7a0e-7709-b61e-5592a8a9e001.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu3FxAgAF9YgRuBsw71LHqZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "ec_5b47a3e6f07fa56ef07a557c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Dean's Midtown",
      "poi_type": "Shopping & Retail",
      "poi_address": "1184 Spring St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-7954-7525-83e8-386de77e5889.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-7954-7525-83e8-386de77e5889",
        "storage_key": "property/6767906449167722/01a020a6-7954-7525-83e8-386de77e5889.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13268517247357955047&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deans-midtown",
      "poi_latitude": "33.7869633",
      "poi_longitude": "-84.3896073",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-c809-71b8-973b-d8af90814901.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a6-c809-71b8-973b-d8af90814901",
        "storage_key": "property/6767906449167722/01a020a6-c809-71b8-973b-d8af90814901.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJR-YbjVsE9YgR5yvqCCM-I7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_7eb66fd19eb0e165c68fd94d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "842 Peachtree St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-7c2d-7795-8d83-23d2cbdad4ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-7c2d-7795-8d83-23d2cbdad4ae",
        "storage_key": "property/6767906449167722/01a020a6-7c2d-7795-8d83-23d2cbdad4ae.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/atlanta-ga-pharmacies/842-peachtree-street-ne-atlanta-ga-30308/storeid=2943?WT.mc_id=LS_GOOGLE_RX_2943",
      "poi_directions_map_url": "https://maps.google.com/?cid=1130648621626452668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.7774986",
      "poi_longitude": "-84.3845652",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-892-8468",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-c7fc-7423-b894-c7e6dd3479ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a6-c7fc-7423-b894-c7e6dd3479ac",
        "storage_key": "property/6767906449167722/01a020a6-c7fc-7423-b894-c7e6dd3479ac.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIYhriWgE9YgRvGrUUe7esA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_945e7bf76563673c2fcad6d6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "22 14th St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-7f38-733f-b7c5-aa9a0062c44e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-7f38-733f-b7c5-aa9a0062c44e",
        "storage_key": "property/6767906449167722/01a020a6-7f38-733f-b7c5-aa9a0062c44e.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/midtownatlanta?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=347012611710925997&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "33.7862472",
      "poi_longitude": "-84.38875569999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 470-552-4201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a6c-7039-b492-1e1a14e35c72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a6c-7039-b492-1e1a14e35c72",
        "storage_key": "property/6767906449167722/01a020a4-7a6c-7039-b492-1e1a14e35c72.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8xL51kwF9YgRrTycvSHW0AQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_d891d42e163544b67ad47bb0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "14TH ST GROCERY AND HALAL MEAT (Near Atlanta Airport)",
      "poi_type": "Shopping & Retail",
      "poi_address": "398 14th St NW, Atlanta, GA 30318, USA",
      "poi_short_description": "Small grocery store & butcher selling halal meats, plus a variety of domestic & imported provisions.",
      "poi_long_description": "Small grocery store & butcher selling halal meats, plus a variety of domestic & imported provisions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-805b-71e8-9371-5119e8361a21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-805b-71e8-9371-5119e8361a21",
        "storage_key": "property/6767906449167722/01a020a6-805b-71e8-9371-5119e8361a21.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ruspagesusa.com/catalog/atlanta/14_th_st_grocery_and_halal_meat/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14199566284054662389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "14th-st-grocery-and-halal-meat-near-atlanta-airport",
      "poi_latitude": "33.7859238",
      "poi_longitude": "-84.4002496",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-458-5917",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a6c-7039-b492-1e1a14e35c72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a6c-7039-b492-1e1a14e35c72",
        "storage_key": "property/6767906449167722/01a020a4-7a6c-7039-b492-1e1a14e35c72.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK0dEFvQE9YgR9QyxhU3-DsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_b8e125e7eb75999a44baec34",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Publix Super Market at The Plaza Midtown",
      "poi_type": "Shopping & Retail",
      "poi_address": "950 W Peachtree St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-845d-72cd-a0c5-bf67dced48c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-845d-72cd-a0c5-bf67dced48c3",
        "storage_key": "property/6767906449167722/01a020a6-845d-72cd-a0c5-bf67dced48c3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1061&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=3963935707884851565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-the-plaza-midtown",
      "poi_latitude": "33.7804802",
      "poi_longitude": "-84.388809",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-253-3544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a6c-7039-b492-1e1a14e35c72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a6c-7039-b492-1e1a14e35c72",
        "storage_key": "property/6767906449167722/01a020a4-7a6c-7039-b492-1e1a14e35c72.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfTK9iWcE9YgRbZH2RIa6Ajc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_f88c997f4cb9a47528854d1c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "375 18th St NW, Atlanta, GA 30363, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-826e-77f8-964f-987b1de2faa7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-826e-77f8-964f-987b1de2faa7",
        "storage_key": "property/6767906449167722/01a020a6-826e-77f8-964f-987b1de2faa7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/atlanta-midtown/2137",
      "poi_directions_map_url": "https://maps.google.com/?cid=3536171801797396388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "33.7932856",
      "poi_longitude": "-84.39933669999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 678-954-4265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7950-766d-b21a-953f864b32d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7950-766d-b21a-953f864b32d8",
        "storage_key": "property/6767906449167722/01a020a4-7950-766d-b21a-953f864b32d8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJtz7EAvgE9YgRpAfjroQBEzE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_c3ee1ec919888d85c244fa51",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "IKEA",
      "poi_type": "Shopping & Retail",
      "poi_address": "441 16th St NW, Atlanta, GA 30363, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a3-f0ab-74be-b0ec-fb7fcd2f17ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a3-f0ab-74be-b0ec-fb7fcd2f17ac",
        "storage_key": "property/6767906449167722/01a020a3-f0ab-74be-b0ec-fb7fcd2f17ac.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/atlanta/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=atlanta",
      "poi_directions_map_url": "https://maps.google.com/?cid=18225472804173140624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "33.78883680000001",
      "poi_longitude": "-84.4051193",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7950-766d-b21a-953f864b32d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7950-766d-b21a-953f864b32d8",
        "storage_key": "property/6767906449167722/01a020a4-7950-766d-b21a-953f864b32d8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJCULE-vEE9YgRkFJI5PPi7fw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "ec_bce9b6e35013be4bb1fc4f86",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Dillard's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1371 Market St NW, Atlanta, GA 30363, USA",
      "poi_short_description": "Department store chain with apparel, shoes & accessories, plus beauty products & home goods.",
      "poi_long_description": "Department store chain with apparel, shoes & accessories, plus beauty products & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-82d1-72a4-95a5-d43742d9fceb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-82d1-72a4-95a5-d43742d9fceb",
        "storage_key": "property/6767906449167722/01a020a6-82d1-72a4-95a5-d43742d9fceb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dillards.com/stores/georgia/atlantic-station-atlanta/0265",
      "poi_directions_map_url": "https://maps.google.com/?cid=2433016631728812189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dillards",
      "poi_latitude": "33.7921763",
      "poi_longitude": "-84.3945371",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-879-0635",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7950-766d-b21a-953f864b32d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7950-766d-b21a-953f864b32d8",
        "storage_key": "property/6767906449167722/01a020a4-7950-766d-b21a-953f864b32d8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ35ZjjlcE9YgRnTDQYrzPwyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_36aa5402a4a2f7244bb36af7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Old Navy",
      "poi_type": "Shopping & Retail",
      "poi_address": "261 19th St NW Suite 1110, Atlanta, GA 30363, USA",
      "poi_short_description": "Chain with a wide range of clothing for the family from jeans to loungewear, plus fun accessories.",
      "poi_long_description": "Chain with a wide range of clothing for the family from jeans to loungewear, plus fun accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-863c-71c1-8999-bfab1b8e8cc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-863c-71c1-8999-bfab1b8e8cc9",
        "storage_key": "property/6767906449167722/01a020a6-863c-71c1-8999-bfab1b8e8cc9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://oldnavy.gap.com/stores/ga/atlanta/oldnavy-3397.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=2268139192955932278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-navy",
      "poi_latitude": "33.7935398",
      "poi_longitude": "-84.3969049",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-872-5138",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7950-766d-b21a-953f864b32d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7950-766d-b21a-953f864b32d8",
        "storage_key": "property/6767906449167722/01a020a4-7950-766d-b21a-953f864b32d8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIY2TC_gE9YgRdo5HMZQMeh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "ec_c1560bac6d7341dae02a9696",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "The Kindezi School at Old Fourth Ward",
      "poi_type": "Education",
      "poi_address": "386 Pine St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://kindezi.org/schools-2/o4w",
      "poi_directions_map_url": "https://maps.google.com/?cid=10856453456829875422&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-kindezi-school-at-old-fourth-ward",
      "poi_latitude": "33.7679782",
      "poi_longitude": "-84.3745928",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-719-4005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-793d-720b-8228-28bf78ee5126",
        "storage_key": "property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS3RYRQ0E9YgR3gToJubeqZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_b25f2b3879245fd04f846472",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Centennial Academy Charter School",
      "poi_type": "Education",
      "poi_address": "531 Luckie St NW, Atlanta, GA 30313, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-869b-732f-90af-93762359c7ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-869b-732f-90af-93762359c7ff",
        "storage_key": "property/6767906449167722/01a020a6-869b-732f-90af-93762359c7ff.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.centennialacademycharter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11758874460627942836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-academy-charter-school",
      "poi_latitude": "33.7696876",
      "poi_longitude": "-84.39518009999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-802-8550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-793d-720b-8228-28bf78ee5126",
        "storage_key": "property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJATHnVH0E9YgRtD0kUAXqL6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_a965d010fff76f061c180bab",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "David T. Howard Middle School",
      "poi_type": "Education",
      "poi_address": "551 John Wesley Dobbs Ave NE, Atlanta, GA 30312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-8918-75eb-9c4b-d81c0c9c1657.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-8918-75eb-9c4b-d81c0c9c1657",
        "storage_key": "property/6767906449167722/01a020a6-8918-75eb-9c4b-d81c0c9c1657.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://howard.atlantapublicschools.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7462350126577969402&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "david-t-howard-middle-school",
      "poi_latitude": "33.7587659",
      "poi_longitude": "-84.3687987",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-802-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-793d-720b-8228-28bf78ee5126",
        "storage_key": "property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJA4ihuAkE9YgR-mhFJOeXj2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_62652585ba8447882fd0142e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Midtown High School",
      "poi_type": "Education",
      "poi_address": "929 Charles Allen Dr NE, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-8ae9-726a-b9f0-5efb8efe91f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-8ae9-726a-b9f0-5efb8efe91f4",
        "storage_key": "property/6767906449167722/01a020a6-8ae9-726a-b9f0-5efb8efe91f4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantapublicschools.us/midtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=18124944716900365978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midtown-high-school",
      "poi_latitude": "33.7805714",
      "poi_longitude": "-84.3722454",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-802-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-793d-720b-8228-28bf78ee5126",
        "storage_key": "property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcTOFGj4E9YgRmnZwoDC9iPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_6fd754c8fe80f7a191fddedc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Virginia Highland Elementary School",
      "poi_type": "Education",
      "poi_address": "774 Virginia Ave NE, Atlanta, GA 30306, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://virginiahighland.atlantapublicschools.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5585150837372331685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-highland-elementary-school",
      "poi_latitude": "33.7818981",
      "poi_longitude": "-84.3621988",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-802-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-793d-720b-8228-28bf78ee5126",
        "storage_key": "property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJTmyeiIF9YgRpaaNXhhxgk0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_0aa6b7b1f005b75411dfe99e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "The Children's School",
      "poi_type": "Education",
      "poi_address": "345 10th St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-8aed-749e-b8f3-5999c1352d58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-8aed-749e-b8f3-5999c1352d58",
        "storage_key": "property/6767906449167722/01a020a6-8aed-749e-b8f3-5999c1352d58.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.tcsatl.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17311591247553604174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-childrens-school",
      "poi_latitude": "33.7815332",
      "poi_longitude": "-84.37593969999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-873-6985",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-793d-720b-8228-28bf78ee5126",
        "storage_key": "property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCU5-dEAE9YgRTqox14QgP_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_ed271fb66c3d94f54013cf5c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "The Goddard School of Atlanta - Midtown",
      "poi_type": "Education",
      "poi_address": "1080 Spring St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "Playful chain school welcoming kids into colorful classrooms for learning and socialization.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-8a4b-7655-9a65-5d276ad85aba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-8a4b-7655-9a65-5d276ad85aba",
        "storage_key": "property/6767906449167722/01a020a6-8a4b-7655-9a65-5d276ad85aba.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.goddardschool.com/schools/ga/atlanta/atlanta-midtown?utm_source=google&utm_medium=business_listings&utm_campaign=school&utm_content=main_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=9643405445568511386&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-goddard-school-of-atlanta---midtown",
      "poi_latitude": "33.7841552",
      "poi_longitude": "-84.3895711",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-541-1936",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-793d-720b-8228-28bf78ee5126",
        "storage_key": "property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa_eISFwE9YgRmr0t6ChC1IU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_d6915d80d5fc6ea8dd384712",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Primrose School of Midtown at Colony Square",
      "poi_type": "Education",
      "poi_address": "1197 Peachtree St NE Apt 554, Atlanta, GA 30361, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-8ce0-77da-9e76-e737849f0d58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-8ce0-77da-9e76-e737849f0d58",
        "storage_key": "property/6767906449167722/01a020a6-8ce0-77da-9e76-e737849f0d58.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.primroseschools.com/schools/midtown-colony-square/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=10215777039959737651&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-midtown-at-colony-square",
      "poi_latitude": "33.7877156",
      "poi_longitude": "-84.3820715",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-745-9797",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-793d-720b-8228-28bf78ee5126",
        "storage_key": "property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7aGRZEQE9YgRM0Vkoxe7xY0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_48924ac6d36d4e717e340f04",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Georgia Institute of Technology",
      "poi_type": "Education",
      "poi_address": "Atlanta, GA 30332, USA",
      "poi_short_description": "This urban research university founded in 1885 is known for engineering, science & business.",
      "poi_long_description": "This urban research university founded in 1885 is known for engineering, science & business.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-0041-7228-88b9-c240d011847f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a4-0041-7228-88b9-c240d011847f",
        "storage_key": "property/6767906449167722/01a020a4-0041-7228-88b9-c240d011847f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gatech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13054475435580638479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-institute-of-technology",
      "poi_latitude": "33.7779791",
      "poi_longitude": "-84.3979638",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-894-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-793d-720b-8228-28bf78ee5126",
        "storage_key": "property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ40_D64oE9YgRD8XYOj7QKrU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_c4fedc7b3d861c90f01c38f3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Georgia State University",
      "poi_type": "Education",
      "poi_address": "Atlanta, GA 30302, USA",
      "poi_short_description": "Public research university located in the Downtown area & known for its sports & business programs.",
      "poi_long_description": "Public research university located in the Downtown area & known for its sports & business programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-0360-7567-b7fe-2ab328ab0e37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a4-0360-7567-b7fe-2ab328ab0e37",
        "storage_key": "property/6767906449167722/01a020a4-0360-7567-b7fe-2ab328ab0e37.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gsu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5386762121144725143&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-state-university",
      "poi_latitude": "33.753068",
      "poi_longitude": "-84.38528190000001",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-413-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-793d-720b-8228-28bf78ee5126",
        "storage_key": "property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJueHvE4YD9YgRl25c4JufwUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_f51ed9ba684ab03ee77261fb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Mercedes-Benz Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1 AMB Dr NW, Atlanta, GA 30313, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-0ac4-747d-92bf-e196069e6f25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a4-0ac4-747d-92bf-e196069e6f25",
        "storage_key": "property/6767906449167722/01a020a4-0ac4-747d-92bf-e196069e6f25.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://mercedesbenzstadium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7296321780679831790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercedes-benz-stadium",
      "poi_latitude": "33.7553232",
      "poi_longitude": "-84.40059049999999",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 470-341-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7945-70ad-8b75-7b8eea7632ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7945-70ad-8b75-7b8eea7632ee",
        "storage_key": "property/6767906449167722/01a020a4-7945-70ad-8b75-7b8eea7632ee.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ45nHOHwD9YgR7vBdgAC-QWU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "ec_ed3a92a087ee70295cb71ff1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Georgia Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "225 Baker St NW, Atlanta, GA 30313, USA",
      "poi_short_description": "One of world's largest aquariums, with permanent exhibits, interactive galleries & animals galore.",
      "poi_long_description": "One of world's largest aquariums, with permanent exhibits, interactive galleries & animals galore.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a3-ffe2-701e-98fc-2cb02d7f0e33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a3-ffe2-701e-98fc-2cb02d7f0e33",
        "storage_key": "property/6767906449167722/01a020a3-ffe2-701e-98fc-2cb02d7f0e33.webp",
        "width": 1280,
        "height": 1148
      },
      "poi_business_url": "https://www.georgiaaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18363269660581776092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-aquarium",
      "poi_latitude": "33.763382",
      "poi_longitude": "-84.3951098",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-581-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a65-7729-9d67-31e8d661d75e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a65-7729-9d67-31e8d661d75e",
        "storage_key": "property/6767906449167722/01a020a4-7a65-7729-9d67-31e8d661d75e.webp",
        "width": 192,
        "height": 176
      },
      "poi_google_place_id": "ChIJGQT0RX4E9YgR3EqvqXZw1_4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "ec_1042ba9492d4642843791eb5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "World of Coca-Cola",
      "poi_type": "Entertainment",
      "poi_address": "121 Baker St NW, Atlanta, GA 30313, USA",
      "poi_short_description": "Memorabilia, films & exhibits (some interactive) about soft drink that debuted in Atlanta in 1886.",
      "poi_long_description": "Memorabilia, films & exhibits (some interactive) about soft drink that debuted in Atlanta in 1886.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-0a08-74b2-b273-4bdf833ebf71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a4-0a08-74b2-b273-4bdf833ebf71",
        "storage_key": "property/6767906449167722/01a020a4-0a08-74b2-b273-4bdf833ebf71.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.worldofcoca-cola.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4900394244069369801&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "world-of-coca-cola",
      "poi_latitude": "33.7625564",
      "poi_longitude": "-84.39243599999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-676-5151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-78ea-77d3-a57c-0099fda99f2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-78ea-77d3-a57c-0099fda99f2f",
        "storage_key": "property/6767906449167722/01a020a4-78ea-77d3-a57c-0099fda99f2f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8yjI7H4E9YgRyacfAZqyAUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_6d47574d026413360cc46792",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "National Center for Civil and Human Rights",
      "poi_type": "Entertainment",
      "poi_address": "100 Ivan Allen Jr Blvd NW, Atlanta, GA 30313, USA",
      "poi_short_description": "Cultural attraction presents artifacts, art & photos from the Civil Rights Era & about human rights.",
      "poi_long_description": "Cultural attraction presents artifacts, art & photos from the Civil Rights Era & about human rights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-92bd-72e9-a55a-6980abd38abd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-92bd-72e9-a55a-6980abd38abd",
        "storage_key": "property/6767906449167722/01a020a6-92bd-72e9-a55a-6980abd38abd.webp",
        "width": 1280,
        "height": 868
      },
      "poi_business_url": "http://www.civilandhumanrights.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4518915228714863530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-center-for-civil-and-human-rights",
      "poi_latitude": "33.7640278",
      "poi_longitude": "-84.39307219999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-999-8990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a07-752d-999c-b7fb0580a012",
        "storage_key": "property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPRzoQ4AE9YgRqgunUXVptj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "ec_19526ef6c941bb0256d6c863",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "State Farm Arena",
      "poi_type": "Entertainment",
      "poi_address": "1 State Farm Dr, Atlanta, GA 30303, USA",
      "poi_short_description": "Home of the Hawks & the Dream, this state-of-the-art venue also hosts concerts & special events.",
      "poi_long_description": "Home of the Hawks & the Dream, this state-of-the-art venue also hosts concerts & special events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-08d3-766c-80fa-c6c2c4a32a6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a4-08d3-766c-80fa-c6c2c4a32a6f",
        "storage_key": "property/6767906449167722/01a020a4-08d3-766c-80fa-c6c2c4a32a6f.webp",
        "width": 1080,
        "height": 620
      },
      "poi_business_url": "https://www.statefarmarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12709393292767748091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "state-farm-arena",
      "poi_latitude": "33.7574062",
      "poi_longitude": "-84.396233",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-878-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a07-752d-999c-b7fb0580a012",
        "storage_key": "property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbUlCkX8D9YgR-18nztzVYLA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "ec_2035008012b3166790876a96",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Tabernacle",
      "poi_type": "Entertainment",
      "poi_address": "152 Luckie St NW, Atlanta, GA 30303, USA",
      "poi_short_description": "Wide range of acts perform at old church (ca. 1910) turned swank music venue with booze & bar bites.",
      "poi_long_description": "Wide range of acts perform at old church (ca. 1910) turned swank music venue with booze & bar bites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-9345-772f-aa71-28cb83f31d7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-9345-772f-aa71-28cb83f31d7e",
        "storage_key": "property/6767906449167722/01a020a6-9345-772f-aa71-28cb83f31d7e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.tabernacleatl.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=17048375409725775301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tabernacle",
      "poi_latitude": "33.7588551",
      "poi_longitude": "-84.39140569999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-659-9022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a07-752d-999c-b7fb0580a012",
        "storage_key": "property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Q3ZVn8E9YgRxZ015hv_l-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_5a8b0f402ade1e1f35a2279c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "SkyView Atlanta",
      "poi_type": "Entertainment",
      "poi_address": "168 Luckie St NW, Atlanta, GA 30303, USA",
      "poi_short_description": "20-story Ferris wheel in Centennial Park providing scenic views from climate-controlled gondolas.",
      "poi_long_description": "20-story Ferris wheel in Centennial Park providing scenic views from climate-controlled gondolas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-9b5f-75b7-9872-81afbd0609f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-9b5f-75b7-9872-81afbd0609f2",
        "storage_key": "property/6767906449167722/01a020a6-9b5f-75b7-9872-81afbd0609f2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.skyviewatlanta.com/?y_source=1_MjAzNDY3MjQwNi03MTUtbG9jYXRpb24ud2Vic2l0ZQ==",
      "poi_directions_map_url": "https://maps.google.com/?cid=4285968454858021836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skyview-atlanta",
      "poi_latitude": "33.7589378",
      "poi_longitude": "-84.3916921",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 678-949-9023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a07-752d-999c-b7fb0580a012",
        "storage_key": "property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3ShBWX8E9YgRzJtXBprRejs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ferris_wheel"
    },
    {
      "id": "ec_2c63faf04cc783e97fe70489",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "College Football Hall of Fame",
      "poi_type": "Entertainment",
      "poi_address": "250 Marietta St NW, Atlanta, GA 30313, USA",
      "poi_short_description": "Sleek modern museum offers exhibits on famous college football players & an indoor field for events.",
      "poi_long_description": "Sleek modern museum offers exhibits on famous college football players & an indoor field for events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-94b9-77e8-a301-d8ab0f6385a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-94b9-77e8-a301-d8ab0f6385a2",
        "storage_key": "property/6767906449167722/01a020a6-94b9-77e8-a301-d8ab0f6385a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cfbhall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17894291972466819922&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "college-football-hall-of-fame",
      "poi_latitude": "33.760276",
      "poi_longitude": "-84.39537330000002",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-880-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-78ea-77d3-a57c-0099fda99f2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-78ea-77d3-a57c-0099fda99f2f",
        "storage_key": "property/6767906449167722/01a020a4-78ea-77d3-a57c-0099fda99f2f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJNRnJ3H8E9YgRUkMCrr1LVfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_e6ebf22a81840cc898ef27e9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Children's Museum of Atlanta",
      "poi_type": "Entertainment",
      "poi_address": "275 Centennial Olympic Park Dr NW, Atlanta, GA 30313, USA",
      "poi_short_description": "Recommended for kids age 2-8, this hands-on museum features an indoor playground, sand table & more.",
      "poi_long_description": "Recommended for kids age 2-8, this hands-on museum features an indoor playground, sand table & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-958a-74ad-8c79-5d572623ee2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-958a-74ad-8c79-5d572623ee2a",
        "storage_key": "property/6767906449167722/01a020a6-958a-74ad-8c79-5d572623ee2a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://childrensmuseumatlanta.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9123950400928075176&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-museum-of-atlanta",
      "poi_latitude": "33.7625707",
      "poi_longitude": "-84.39173269999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-659-5437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-78ea-77d3-a57c-0099fda99f2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-78ea-77d3-a57c-0099fda99f2f",
        "storage_key": "property/6767906449167722/01a020a4-78ea-77d3-a57c-0099fda99f2f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ38j8xX4E9YgRqM2Zg4zInn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_60d37c2aee756c9bcf7dc4bd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Centennial Olympic Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Atlanta, GA 30313, USA",
      "poi_short_description": "Home of the 1996 Olympic games now filled with walking paths, water gardens & the Fountain of Rings.",
      "poi_long_description": "Home of the 1996 Olympic games now filled with walking paths, water gardens & the Fountain of Rings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-185a-7238-838e-6ea3b5ac5718.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a4-185a-7238-838e-6ea3b5ac5718",
        "storage_key": "property/6767906449167722/01a020a4-185a-7238-838e-6ea3b5ac5718.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gwcca.org/centennial-olympic-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6004367012448251227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-olympic-park",
      "poi_latitude": "33.760463",
      "poi_longitude": "-84.3930831",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-223-4412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a5e-778a-8494-97cc6cc91bcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a5e-778a-8494-97cc6cc91bcc",
        "storage_key": "property/6767906449167722/01a020a4-7a5e-778a-8494-97cc6cc91bcc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIRYhpn8E9YgRWy0NPvzLU1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_448b85a0ad3c9982de1a8223",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Emory University Hospital Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "550 Peachtree St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-16d0-748d-8de0-cd677e354231.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a4-16d0-748d-8de0-cd677e354231",
        "storage_key": "property/6767906449167722/01a020a4-16d0-748d-8de0-cd677e354231.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.emoryhealthcare.org/locations/hospitals/emory-university-hospital-midtown?&utm_campaign=brand_euh_ra_gmb-locations&utm_source=google&utm_medium=gmb&utm_content=gmb_locations?&utm_campaign=brand_all_non&utm_source=google&utm_medium=gmb&utm_content=gmb-locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=15043808532116501154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emory-university-hospital-midtown",
      "poi_latitude": "33.7686442",
      "poi_longitude": "-84.38619290000001",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-686-4411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a1e-773a-ad08-a175e1766593.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a1e-773a-ad08-a175e1766593",
        "storage_key": "property/6767906449167722/01a020a4-7a1e-773a-ad08-a175e1766593.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ42AWonoE9YgRonLLiSdYxtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_a9537b43d0d3f0e828a105a5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Concentra Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "688 Spring St NW, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-963c-715b-a7e1-3bdead1acf4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-963c-715b-a7e1-3bdead1acf4a",
        "storage_key": "property/6767906449167722/01a020a6-963c-715b-a7e1-3bdead1acf4a.webp",
        "width": 1280,
        "height": 887
      },
      "poi_business_url": "http://www.concentra.com/?utm_source=Yext&utm_medium=Organic&utm_campaign=Homepage%20Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=925693518154110771&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concentra-urgent-care",
      "poi_latitude": "33.7734083",
      "poi_longitude": "-84.38911069999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-881-1155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a07-752d-999c-b7fb0580a012",
        "storage_key": "property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2Uc9T2QE9YgRMxd1qFm52Aw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_89dc8bf0c7d9729e77802843",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Peachtree Immediate Care - Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "450 14th St NW, Atlanta, GA 30318, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-a19e-77cf-af6e-29b64d9b29b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-a19e-77cf-af6e-29b64d9b29b3",
        "storage_key": "property/6767906449167722/01a020a6-a19e-77cf-af6e-29b64d9b29b3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.peachtreemed.com/location/midtown/",
      "poi_directions_map_url": "https://maps.google.com/?cid=601517532570486055&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peachtree-immediate-care---midtown",
      "poi_latitude": "33.7859572",
      "poi_longitude": "-84.4021827",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-480-9797",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a07-752d-999c-b7fb0580a012",
        "storage_key": "property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGdcc7vME9YgRJ4UIRwIFWQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_db4dcb3f39b313b140915b7e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Walgreens Specialty Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "565 Peachtree St NE Spc B, Atlanta, GA 30308, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-9e80-74f0-9775-ecf10325711c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-9e80-74f0-9775-ecf10325711c",
        "storage_key": "property/6767906449167722/01a020a6-9e80-74f0-9775-ecf10325711c.webp",
        "width": 750,
        "height": 421
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-565+peachtree+st+ne-atlanta-ga-30308/id=21146",
      "poi_directions_map_url": "https://maps.google.com/?cid=15196450436197706635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-specialty-pharmacy",
      "poi_latitude": "33.770088",
      "poi_longitude": "-84.3848515",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-662-3433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-c7fc-7423-b894-c7e6dd3479ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a6-c7fc-7423-b894-c7e6dd3479ac",
        "storage_key": "property/6767906449167722/01a020a6-c7fc-7423-b894-c7e6dd3479ac.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvRg8z4cF9YgRi-tkUCij5NI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_25efe6aed10bda92aa68843d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Carbon Performance | Atlanta",
      "poi_type": "Health and Wellness",
      "poi_address": "950 West Marietta St NW Ste c 130, Atlanta, GA 30318, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-9e0c-760b-8900-cb4137d701ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-9e0c-760b-8900-cb4137d701ea",
        "storage_key": "property/6767906449167722/01a020a6-9e0c-760b-8900-cb4137d701ea.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://carbonperformance.com/atlanta-ga/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13442088095970359833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carbon-performance--atlanta",
      "poi_latitude": "33.7828253",
      "poi_longitude": "-84.4189502",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 828-470-7923",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a07-752d-999c-b7fb0580a012",
        "storage_key": "property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9yKCSZUF9YgRGfrRb-fji7o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_8ae6328cb576bc8a8a833ccf",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "CorePower Yoga - Atlanta Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "860 Peachtree St NE Suite J, Atlanta, GA 30308, USA",
      "poi_short_description": "Branch of a fitness chain offering vigorous yoga classes with a focus on mindfulness.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-a0c4-7228-99a5-0512350132dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-a0c4-7228-99a5-0512350132dc",
        "storage_key": "property/6767906449167722/01a020a6-a0c4-7228-99a5-0512350132dc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.corepoweryoga.com/yoga-studios/ga/atlanta/atlanta-midtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=3395339368669349519&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corepower-yoga---atlanta-midtown",
      "poi_latitude": "33.7784663",
      "poi_longitude": "-84.38542319999999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 833-448-2561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-793d-720b-8228-28bf78ee5126",
        "storage_key": "property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZUNWe2gE9YgRj4ZvoSqrHi8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_6ab51b6e7777992ac5dd90bf",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "GATech Campus Recreation Center",
      "poi_type": "Health and Wellness",
      "poi_address": "750 Ferst Dr, Atlanta, GA 30332, USA",
      "poi_short_description": "Sport complex with fitness classes & courts for team sports, plus pools, waterslides & a lazy river.",
      "poi_long_description": "Sport complex with fitness classes & courts for team sports, plus pools, waterslides & a lazy river.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-9d5b-763c-9103-d1477876af81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-9d5b-763c-9103-d1477876af81",
        "storage_key": "property/6767906449167722/01a020a6-9d5b-763c-9103-d1477876af81.webp",
        "width": 1280,
        "height": 947
      },
      "poi_business_url": "https://crc.gatech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16609318414471765650&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gatech-campus-recreation-center",
      "poi_latitude": "33.7755602",
      "poi_longitude": "-84.40356510000001",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-385-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a07-752d-999c-b7fb0580a012",
        "storage_key": "property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ47Mo6GIE9YgRkp7xFxkngOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_e1538330f2e980a134da7f97",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "933 Peachtree St NE #939A, Atlanta, GA 30309, USA",
      "poi_short_description": "Group, treadmill-based workout studio, featuring certified instructors and fitness training in an energetic environment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-a513-77bf-9f19-6dfb1a578918.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-a513-77bf-9f19-6dfb1a578918",
        "storage_key": "property/6767906449167722/01a020a6-a513-77bf-9f19-6dfb1a578918.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/atlanta-georgia-0137?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=621678546688391647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "33.780276",
      "poi_longitude": "-84.3839747",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-747-7107",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a07-752d-999c-b7fb0580a012",
        "storage_key": "property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCWpDnUIE9YgR37nXK1iloAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_12b47f7973a243fafdd74938",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Flag Building (Smithgall Student Services Building)",
      "poi_type": "Education",
      "poi_address": "Smithgall Building, 353 Ferst Dr NW, Atlanta, GA 30332, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-a0d5-756d-82fb-4b3507796348.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-a0d5-756d-82fb-4b3507796348",
        "storage_key": "property/6767906449167722/01a020a6-a0d5-756d-82fb-4b3507796348.webp",
        "width": 1280,
        "height": 885
      },
      "poi_business_url": "https://studentlife.gatech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4904442661930038225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flag-building-smithgall-student-services-building",
      "poi_latitude": "33.7744069",
      "poi_longitude": "-84.39961939999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-894-6367",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-793d-720b-8228-28bf78ee5126",
        "storage_key": "property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlc4sE4kE9YgR0XOcvZ0UEEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_cde8b825557f5a0feec7a836",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Piedmont Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Atlanta, GA 30309, USA",
      "poi_short_description": "Sprawling park featuring jogging paths, basketball courts, dog parks, a farmers' market & more.",
      "poi_long_description": "Sprawling park featuring jogging paths, basketball courts, dog parks, a farmers' market & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-159d-71bb-9abe-218d12781179.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a4-159d-71bb-9abe-218d12781179",
        "storage_key": "property/6767906449167722/01a020a4-159d-71bb-9abe-218d12781179.webp",
        "width": 736,
        "height": 485
      },
      "poi_business_url": "https://piedmontpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17559229622006002958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-park",
      "poi_latitude": "33.7879265",
      "poi_longitude": "-84.37216819999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-875-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a5e-778a-8494-97cc6cc91bcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a5e-778a-8494-97cc6cc91bcc",
        "storage_key": "property/6767906449167722/01a020a4-7a5e-778a-8494-97cc6cc91bcc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGaxkUDkE9YgRDjUv9U7qrvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_e42e92a11f0756877728e3e7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Atlanta Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1345 Piedmont Ave NE, Atlanta, GA 30309, USA",
      "poi_short_description": "30-acre garden with a conservatory & fountains playing host to concerts, cocktail parties & more.",
      "poi_long_description": "30-acre garden with a conservatory & fountains playing host to concerts, cocktail parties & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-16f9-727c-b25a-878af194d60f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a4-16f9-727c-b25a-878af194d60f",
        "storage_key": "property/6767906449167722/01a020a4-16f9-727c-b25a-878af194d60f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantabg.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11595354526965683893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlanta-botanical-garden",
      "poi_latitude": "33.7899568",
      "poi_longitude": "-84.37259879999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-876-5859",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a07-752d-999c-b7fb0580a012",
        "storage_key": "property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RXVJTgE9YgRtdaB6IH56qA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "ec_5ead4ca0e323e4c5f271771c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Beltline Shed at Ponce City Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "Eastside Trail, Atlanta, GA 30308, USA",
      "poi_short_description": "Farmers' market and events venue at Ponce City Market featuring food, entertainment, and skyline views.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-a7e4-701e-9559-afa55edbd199.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-a7e4-701e-9559-afa55edbd199",
        "storage_key": "property/6767906449167722/01a020a6-a7e4-701e-9559-afa55edbd199.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3606484372464342111&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beltline-shed-at-ponce-city-market",
      "poi_latitude": "33.7723652",
      "poi_longitude": "-84.36461450000002",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7950-766d-b21a-953f864b32d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7950-766d-b21a-953f864b32d8",
        "storage_key": "property/6767906449167722/01a020a4-7950-766d-b21a-953f864b32d8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJeZd2dhoE9YgRXxS8xG3ODDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farmers_market"
    },
    {
      "id": "ec_e0de7c13d1ea77d406bc8354",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Historic Fourth Ward Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "680 Dallas St NE, Atlanta, GA 30308, USA",
      "poi_short_description": "A 17-acre park with a splash fountain, skate park & amphitheater, adjacent to the Atlanta Beltline.",
      "poi_long_description": "A 17-acre park with a splash fountain, skate park & amphitheater, adjacent to the Atlanta Beltline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-a778-733f-89ec-e0f0e462bbbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-a778-733f-89ec-e0f0e462bbbb",
        "storage_key": "property/6767906449167722/01a020a6-a778-733f-89ec-e0f0e462bbbb.webp",
        "width": 1280,
        "height": 667
      },
      "poi_business_url": "http://www.h4wpc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1819443021458306877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "historic-fourth-ward-park",
      "poi_latitude": "33.7694043",
      "poi_longitude": "-84.3647968",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-546-6813",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a5e-778a-8494-97cc6cc91bcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a5e-778a-8494-97cc6cc91bcc",
        "storage_key": "property/6767906449167722/01a020a4-7a5e-778a-8494-97cc6cc91bcc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZSnz-A8E9YgRPfcVx8n1Pxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_266ad1b401f780d5345bfec5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Atlantic Station",
      "poi_type": "Shopping & Retail",
      "poi_address": "1380 Atlantic Dr NW, Atlanta, GA 30363, USA",
      "poi_short_description": "Upmarket retail complex with department & specialty stores, a multiplex & a range of dining options.",
      "poi_long_description": "Upmarket retail complex with department & specialty stores, a multiplex & a range of dining options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-abc8-732e-b160-eeda988e8046.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-abc8-732e-b160-eeda988e8046",
        "storage_key": "property/6767906449167722/01a020a6-abc8-732e-b160-eeda988e8046.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://atlanticstation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16075264230802959861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlantic-station",
      "poi_latitude": "33.79249830000001",
      "poi_longitude": "-84.39651820000002",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-410-4010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7950-766d-b21a-953f864b32d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7950-766d-b21a-953f864b32d8",
        "storage_key": "property/6767906449167722/01a020a4-7950-766d-b21a-953f864b32d8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJk8PKSvYE9YgR9a2Nw6XPFt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_238e78439e721b2dda5d6fd2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Woodruff Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "91 Peachtree St, Atlanta, GA 30303, USA",
      "poi_short_description": "City park with 2 fountains, playgrounds, sculptures, chess court & pavilion, plus events.",
      "poi_long_description": "City park with 2 fountains, playgrounds, sculptures, chess court & pavilion, plus events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-a8ac-70d4-95e5-178ec7a24d6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-a8ac-70d4-95e5-178ec7a24d6f",
        "storage_key": "property/6767906449167722/01a020a6-a8ac-70d4-95e5-178ec7a24d6f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantaga.gov/government/departments/department-parks-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=10797897627385162082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodruff-park",
      "poi_latitude": "33.755217",
      "poi_longitude": "-84.388628",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-546-6744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a5e-778a-8494-97cc6cc91bcc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a5e-778a-8494-97cc6cc91bcc",
        "storage_key": "property/6767906449167722/01a020a4-7a5e-778a-8494-97cc6cc91bcc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXwkh_4YD9YgRYmlTsa7W2ZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_7c3babef158c6231f1397063",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "SEC District",
      "poi_type": "Transportation & Transit",
      "poi_address": "100 Centennial Olympic Park Dr NW, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-aae6-736e-a41c-2396e63d3c2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-aae6-736e-a41c-2396e63d3c2f",
        "storage_key": "property/6767906449167722/01a020a6-aae6-736e-a41c-2396e63d3c2f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://itsmarta.com/Omni.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6143183905929850805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sec-district",
      "poi_latitude": "33.7565924",
      "poi_longitude": "-84.3967844",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7ce7-7499-a815-b76c7a33fa20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7ce7-7499-a815-b76c7a33fa20",
        "storage_key": "property/6767906449167722/01a020a4-7ce7-7499-a815-b76c7a33fa20.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ77wFoX8D9YgRtW_Y5jb5QFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_8cdd9654378670264475ee1a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Vine City",
      "poi_type": "Transportation & Transit",
      "poi_address": "502 Rhodes St NW, Atlanta, GA 30314, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-ace7-7595-aff5-29886784f511.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-ace7-7595-aff5-29886784f511",
        "storage_key": "property/6767906449167722/01a020a6-ace7-7595-aff5-29886784f511.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://itsmarta.com/Vine-City.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4868281726230102250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vine-city",
      "poi_latitude": "33.7565738",
      "poi_longitude": "-84.4040313",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7ce7-7499-a815-b76c7a33fa20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7ce7-7499-a815-b76c7a33fa20",
        "storage_key": "property/6767906449167722/01a020a4-7ce7-7499-a815-b76c7a33fa20.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1zEIAX0D9YgR6oB4zm-cj0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_a009837b101cfe68bee4d992",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "North Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "713 W Peachtree St NW, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-2083-721b-b750-f68532416ed3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a4-2083-721b-b750-f68532416ed3",
        "storage_key": "property/6767906449167722/01a020a4-2083-721b-b750-f68532416ed3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://itsmarta.com/North-Ave.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6649073214810790357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-ave",
      "poi_latitude": "33.77179",
      "poi_longitude": "-84.38709",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7ce7-7499-a815-b76c7a33fa20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7ce7-7499-a815-b76c7a33fa20",
        "storage_key": "property/6767906449167722/01a020a4-7ce7-7499-a815-b76c7a33fa20.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJu65s0W4E9YgR1ZlcTtxARlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_52d335b9d7788bd8cda1989f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Midtown",
      "poi_type": "Transportation & Transit",
      "poi_address": "Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-6c5a-7708-8b66-e398b37ac3c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a4-6c5a-7708-8b66-e398b37ac3c3",
        "storage_key": "property/6767906449167722/01a020a4-6c5a-7708-8b66-e398b37ac3c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://itsmarta.com/Midtown.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3874113686536918320&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midtown",
      "poi_latitude": "33.78107",
      "poi_longitude": "-84.38632",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7ce7-7499-a815-b76c7a33fa20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7ce7-7499-a815-b76c7a33fa20",
        "storage_key": "property/6767906449167722/01a020a4-7ce7-7499-a815-b76c7a33fa20.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJdym9WF0E9YgRMBWDOd-dwzU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_e35e85e629d4c518378bc412",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Arts Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-242f-7696-b532-ce9b84019574.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a4-242f-7696-b532-ce9b84019574",
        "storage_key": "property/6767906449167722/01a020a4-242f-7696-b532-ce9b84019574.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.itsmarta.com/Arts-Center.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6693853067366476356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arts-center",
      "poi_latitude": "33.78918",
      "poi_longitude": "-84.38727999999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7ce7-7499-a815-b76c7a33fa20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7ce7-7499-a815-b76c7a33fa20",
        "storage_key": "property/6767906449167722/01a020a4-7ce7-7499-a815-b76c7a33fa20.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6XSS4FoE9YgRRKoJM-ZX5Vw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_9517f43ff35a7ad18157c8ad",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Amtrak",
      "poi_type": "Transportation & Transit",
      "poi_address": "1688 Peachtree Rd NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-b210-769c-b238-6173d6c8f57c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-b210-769c-b238-6173d6c8f57c",
        "storage_key": "property/6767906449167722/01a020a6-b210-769c-b238-6173d6c8f57c.webp",
        "width": 679,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/stations/atl",
      "poi_directions_map_url": "https://maps.google.com/?cid=11594273034950126537&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amtrak",
      "poi_latitude": "33.7993975",
      "poi_longitude": "-84.3926057",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 866-332-0334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a07-752d-999c-b7fb0580a012",
        "storage_key": "property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa4Hqac4F9YgRyasXbeUh56A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_e582a37dee7487f48ede589c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "MARTA",
      "poi_type": "Transportation & Transit",
      "poi_address": "20 Broad St SW, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-b982-728f-953a-82eea43bc2e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-b982-728f-953a-82eea43bc2e3",
        "storage_key": "property/6767906449167722/01a020a6-b982-728f-953a-82eea43bc2e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://itsmarta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9905538713891598483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marta",
      "poi_latitude": "33.7534684",
      "poi_longitude": "-84.3912102",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a07-752d-999c-b7fb0580a012",
        "storage_key": "property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK8uQU4ED9YgRk3BjfvqKd4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "ec_3d05e60353c7604ce38c8de7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Atlanta Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "232 Forsyth St SW, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-b45b-73e8-8b3c-c4b59e22635f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-b45b-73e8-8b3c-c4b59e22635f",
        "storage_key": "property/6767906449167722/01a020a6-b45b-73e8-8b3c-c4b59e22635f.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.greyhound.com/en-us/bus-station-410124",
      "poi_directions_map_url": "https://maps.google.com/?cid=916026877153485098&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlanta-bus-station",
      "poi_latitude": "33.7485402",
      "poi_longitude": "-84.3963663",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 404-584-1728",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-c83b-75bb-b5fb-7597ef70f20d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a6-c83b-75bb-b5fb-7597ef70f20d",
        "storage_key": "property/6767906449167722/01a020a6-c83b-75bb-b5fb-7597ef70f20d.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJqeJICHgD9YgRKqFxaZdhtgw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_060bf3568d72301250810a58",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Centennial Olympic Park",
      "poi_type": "Transportation & Transit",
      "poi_address": "Centennial Olympic Park Dr NW, Atlanta, GA 30303, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-b457-7488-89fe-a95ee139db6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-b457-7488-89fe-a95ee139db6e",
        "storage_key": "property/6767906449167722/01a020a6-b457-7488-89fe-a95ee139db6e.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12131305881373660027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-olympic-park",
      "poi_latitude": "33.759425",
      "poi_longitude": "-84.391975",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7ce7-7499-a815-b76c7a33fa20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7ce7-7499-a815-b76c7a33fa20",
        "storage_key": "property/6767906449167722/01a020a4-7ce7-7499-a815-b76c7a33fa20.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJwd6gRH8E9YgRe1PiuGwOW6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tram_stop"
    },
    {
      "id": "ec_b645187d0129e84536f545bd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Hartsfield-Jackson Atlanta International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6000 N Terminal Pkwy Ste 4000, Atlanta, GA 30320, USA",
      "poi_short_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_long_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-b58d-755f-83cb-9d8a006ac26e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-b58d-755f-83cb-9d8a006ac26e",
        "storage_key": "property/6767906449167722/01a020a6-b58d-755f-83cb-9d8a006ac26e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690397784234438728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hartsfield-jackson-atlanta-international-airport",
      "poi_latitude": "33.6324187",
      "poi_longitude": "-84.4333116",
      "poi_miles_from_property": "13.5 mi",
      "poi_walking_minutes": "5 hours 2 mins",
      "poi_biking_minutes": "1 hour 38 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 800-897-1910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-c81b-75cf-aa62-4c6100b2edd6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a6-c81b-75cf-aa62-4c6100b2edd6",
        "storage_key": "property/6767906449167722/01a020a6-c81b-75cf-aa62-4c6100b2edd6.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVkD4S_99IgRSLCSGO-jF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_388c8f30ee48549ca16a9762",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Tower Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "675 W Peachtree St NW, Atlanta, GA 30308, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-baef-732a-9718-9c1f469377cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-baef-732a-9718-9c1f469377cc",
        "storage_key": "property/6767906449167722/01a020a6-baef-732a-9718-9c1f469377cc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cbre.com/properties/properties-for-lease/retail/details/US-SMPL-91481/the-exchange-at-tower-square-675-west-peachtree-street-northwest-atlanta-ga-30308",
      "poi_directions_map_url": "https://maps.google.com/?cid=8150718751859054784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tower-square",
      "poi_latitude": "33.7727758",
      "poi_longitude": "-84.3867653",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7950-766d-b21a-953f864b32d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7950-766d-b21a-953f864b32d8",
        "storage_key": "property/6767906449167722/01a020a4-7950-766d-b21a-953f864b32d8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJy6P2hsIF9YgRwJisPIUrHXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_63db8697e305672f533cd287",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Federal Reserve Bank of Atlanta",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 Peachtree St NE, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-bbb7-763c-8628-13ae5a7be04e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-bbb7-763c-8628-13ae5a7be04e",
        "storage_key": "property/6767906449167722/01a020a6-bbb7-763c-8628-13ae5a7be04e.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.atlantafed.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10811497039753145462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "federal-reserve-bank-of-atlanta",
      "poi_latitude": "33.782425",
      "poi_longitude": "-84.3847892",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-498-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-c806-70fc-8e1c-c432e6139b41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a6-c806-70fc-8e1c-c432e6139b41",
        "storage_key": "property/6767906449167722/01a020a6-c806-70fc-8e1c-c432e6139b41.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC_yk6kIE9YgRdmysoEYnCpY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "ec_eed82b7624e0d2221a724cf2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Piedmont Atlanta",
      "poi_type": "Health and Wellness",
      "poi_address": "1968 Peachtree Rd NW, Atlanta, GA 30309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-bd70-77f8-9125-a8d07b8f3465.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-bd70-77f8-9125-a8d07b8f3465",
        "storage_key": "property/6767906449167722/01a020a6-bd70-77f8-9125-a8d07b8f3465.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-atlanta?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MTI5OTY4MzYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10361705813315035831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-atlanta",
      "poi_latitude": "33.8088868",
      "poi_longitude": "-84.394939",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 404-605-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a1e-773a-ad08-a175e1766593.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a1e-773a-ad08-a175e1766593",
        "storage_key": "property/6767906449167722/01a020a4-7a1e-773a-ad08-a175e1766593.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ2L4-KkF9YgRtyK-3YkszI8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_245298a31ba97144b4f98e1c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "One Coca-Cola Plaza",
      "poi_type": "Major Employers & Offices",
      "poi_address": "528 Luckie St NW, Atlanta, GA 30313, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-69bb-74cb-a806-84405ffc4c7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a4-69bb-74cb-a806-84405ffc4c7b",
        "storage_key": "property/6767906449167722/01a020a4-69bb-74cb-a806-84405ffc4c7b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.coca-colacompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12947067275745438064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "one-coca-cola-plaza",
      "poi_latitude": "33.7711478",
      "poi_longitude": "-84.397268",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-676-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a07-752d-999c-b7fb0580a012",
        "storage_key": "property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv5ISQokD9YgRcCnkPRc5rbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_374f80687c6c12a06964dd5f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Georgia World Congress Center",
      "poi_type": "Entertainment",
      "poi_address": "285 Andrew Young International Blvd NW, Atlanta, GA 30313, USA",
      "poi_short_description": "Huge, architectural marvel presenting a slate of conferences, shows and exhibitions.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-c1c0-749c-9589-753593dae56e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-c1c0-749c-9589-753593dae56e",
        "storage_key": "property/6767906449167722/01a020a6-c1c0-749c-9589-753593dae56e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.gwcca.org/georgia-world-congress-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=15144273618014860395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-world-congress-center",
      "poi_latitude": "33.7582368",
      "poi_longitude": "-84.39710610000002",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-223-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a07-752d-999c-b7fb0580a012",
        "storage_key": "property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWVKVj4EE9YgRa3QYJ55EK9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_8b1068ea0a0e80f989cf3f2c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Emory University",
      "poi_type": "Education",
      "poi_address": "201 Dowman Dr, Atlanta, GA 30322, USA",
      "poi_short_description": "Research-geared private school founded in 1836 & renowned for its healthcare program.",
      "poi_long_description": "Research-geared private school founded in 1836 & renowned for its healthcare program.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a3-fabc-7648-b985-5f3d52cefe92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a3-fabc-7648-b985-5f3d52cefe92",
        "storage_key": "property/6767906449167722/01a020a3-fabc-7648-b985-5f3d52cefe92.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.emory.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6401157007639682133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emory-university",
      "poi_latitude": "33.7973735",
      "poi_longitude": "-84.3252791",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 404-727-6123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-793d-720b-8228-28bf78ee5126",
        "storage_key": "property/6767906449167722/01a020a4-793d-720b-8228-28bf78ee5126.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHU-KgPcG9YgRVZzdN2J61Vg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_77175a6fde89db0fd28eb798",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "source": "generator",
      "poi_name": "Children's Healthcare of Atlanta - Egleston Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1405 Clifton Rd NE, Atlanta, GA 30322, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a6-c07f-714b-bc4d-ab3eedf16de5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a020a6-c07f-714b-bc4d-ab3eedf16de5",
        "storage_key": "property/6767906449167722/01a020a6-c07f-714b-bc4d-ab3eedf16de5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.choa.org/locations/egleston-hospital?cid=_na1_ch-Yx_na3_na4_d-yxll_na6",
      "poi_directions_map_url": "https://maps.google.com/?cid=10949268201800251684&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-healthcare-of-atlanta---egleston-hospital",
      "poi_latitude": "33.7934917",
      "poi_longitude": "-84.3195325",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 404-785-5437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a020a4-7a07-752d-999c-b7fb0580a012",
        "storage_key": "property/6767906449167722/01a020a4-7a07-752d-999c-b7fb0580a012.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR4J4LPoG9YgRJLnI9mqd85c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    }
  ],
  "office_hours": [
    {
      "id": "custom_dd0f1a19-6f8f-497a-b3ca-c3c4c9db52c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_af4f3b1d-12c3-4637-94bf-bb11a03fd08a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_0a5d4805-6cb0-4aff-ac99-3e6e7eaeba6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_a824483f-6128-4431-b757-98d32f21ae47",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_0645fb9b-6916-4829-a954-577ca766e7c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_b8a563fa12f951d6b754c3df",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "rating": "5",
      "name": "Joseph Felt",
      "text": "Great building and well constructed. As a realtor in Miami, I bought a unit here as a great place to live due to location and closely looking at the construction. I always look at buildings in view of construction and if there is a strong honest Board to maintain the building. The few complaints I saw were unwarranted. I look at property value and appreciation potential. The Board is tasked with more than the average buyer realizes and they do a fine job. I owned in another building with a weak board where noise and parties were a regular occurrence and the building wasn't being maintained like I see here in MidCity Lofts. Property values diminished in that building and was happy to get out before they dropped to the ground. As a part time residence, it's a great place, CLEAN and well maintained, a decent reserve fund. Location with good restaurants, groceries and close to a MARTA stop that is walk able, a real plus in my book and great for resale. I was surprised there wasn't much of a raise in the HOA in correspondence to what I see happening in our Nation. I would buy again here and definetly look at this as being one of the better communities in Midtown Atlanta with a great Board, Concierge Staff and CAM.",
      "date": "2026-05-31",
      "title": "false"
    },
    {
      "id": "ec_cd5deca104742c63fcb1a9eb",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "rating": "5",
      "name": "Subhajit Bag",
      "text": "MidCity Lofts in Midtown Atlanta is a really stylish and modern place to live. The building has a sleek, industrial vibe with big windows that let in tons of natural light and give great views of the city skyline. The location is unbeatable—you’re right in the heart of Midtown, close to Georgia Tech, restaurants, bars, and MARTA, which makes it super convenient. The rooftop pool and lounge area are definitely highlights; it’s a great spot to relax or hang out with friends. The building feels safe and well-maintained, with secure access and attentive management. It can get a bit pricey compared to other options in the area, but the amenities and the central location make it a strong choice if you want to enjoy city living with style.",
      "date": "2025-08-29",
      "title": "false"
    },
    {
      "id": "ec_f69f6ee2129caf5ca0f53f5e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "rating": "5",
      "name": "Victoria Chang",
      "text": "Great building, quiet (minus the construction that will end at some point), really well-managed building. Close to Tech. Nice residents. Great front desk staff who help me on so many things, especially when I’m not in town. Great little gym. It’s also very quiet. The building is constructed well and I never hear anyone when I’m in my unit. Love living here.",
      "date": "2026-03-13",
      "title": "false"
    },
    {
      "id": "ec_37c15d10dcabd41fa63ce75e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167722",
      "rating": "5",
      "name": "Lathiel Wright",
      "text": "There isn't good access to the loading dock but it is a short walk to the elevator. The elevator is able to be reserved and set to independent. They have they masonite floor protection available. Even with early morning traffic, deliveries, and taxis the move-in went smoothly.",
      "date": "2017-02-10",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [
    {
      "id": "custom_fa10eafc-0c43-43f2-8673-52e015d3f3ee",
      "question": "How do I apply for an apartment?",
      "answer": "Our online application is easy and only takes 15 minutes to complete. Start by creating your account. From there, fill in the information requested and take a quick survey just in case we need to match you with a roommate. Once you input your guarantor information and other financial details, you’ll be on your way to signing your own personalized, individual lease agreement. For any questions along the way, contact our leasing office and one of our friendly team members will be happy to assist you.",
      "category": "false",
      "source": "custom"
    },
    {
      "id": "custom_49fd7c19-cc62-4ea7-9b06-83e8bbe87c53",
      "question": "What is an individual lease?",
      "answer": "Our online application is easy and only takes 15 minutes to complete. Start by creating your account. From there, fill in the information requested and take a quick survey just in case we need to match you with a roommate. Once you input your guarantor information and other financial details, you’ll be on your way to signing your own personalized, individual lease agreement. For any questions along the way, contact our leasing office and one of our friendly team members will be happy to assist you.",
      "category": "false",
      "source": "custom"
    },
    {
      "id": "custom_c59e06eb-c07b-464e-8b84-20f6797023a8",
      "question": "Where is the Stadium House leasing office located?",
      "answer": "The leasing office is located on the 2nd floor just up the grand staircase.",
      "category": "false",
      "source": "custom"
    },
    {
      "id": "custom_7328ea2f-45ff-4447-a670-fbdd919b823e",
      "question": "How long of a lease can I sign?",
      "answer": "All leases at Stadium house are 12-month installments.",
      "category": "false",
      "source": "custom"
    },
    {
      "id": "custom_21cfe1f8-da4c-4d5d-b07e-cffda7dabda4",
      "question": "Is on-site parking available? How much is parking?",
      "answer": "Stadium House has both standard and reserved parking spaces. If you’re searching for parking, read our article, Ultimate Guide to Parking.",
      "category": "false",
      "source": "custom"
    },
    {
      "id": "custom_93df55bd-859d-4ab6-977e-cc6a7100f66d",
      "question": "Do you allow pets?",
      "answer": "Stadium House welcomes pets, but with a few restrictions. (Believe it or not, we’ve actually been asked about pet skunks. We said no. You’re welcome.)\n\n\nRestricted animals include (but are not limited to) aggressive dog breeds, such as Pit Bulls, Rottweilers, German Shepherds, Huskies, Malamutes, Dobermans, Chow Chows, and Great Danes. If you’re curious about another type of animal, feel free to contact the Rambler Athens team.",
      "category": "false",
      "source": "custom"
    }
  ],
  "lead_collectors": [],
  "hyperlocal_queries": [],
  "custom_fields": [
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlVPQXRUYTRZV1dFcG13dkI2RUZhY1E9PSIsInZhbHVlIjoiZ242dHhBa2lwVlRjeldCTVZScmpyQT09IiwibWFjIjoiNjNjNTQ5MzIwMWJlMWU3NjBhZTEwYTQ3ZjZkZTg5NTEyYjA3ODJlYmQyOTFiOTc4YmQ3ZjIyZjZiYTBhMGNlYyJ9"
    }
  ],
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlVPQXRUYTRZV1dFcG13dkI2RUZhY1E9PSIsInZhbHVlIjoiZ242dHhBa2lwVlRjeldCTVZScmpyQT09IiwibWFjIjoiNjNjNTQ5MzIwMWJlMWU3NjBhZTEwYTQ3ZjZkZTg5NTEyYjA3ODJlYmQyOTFiOTc4YmQ3ZjIyZjZiYTBhMGNlYyJ9",
  "custom_audioeye_site_id": "151f3d84-e3e3-4d3d-88dc-c7f504c207bf",
  "custom_audioeye_site_hash": "75840a3a2c7452f01f60e35703af5fa6"
};

export const generatedAt = '2026-09-09T19:45:00.211Z';
